// extracted by mini-css-extract-plugin
export default {"container":"b2TZ17GrL7PUO70KI_ev"};